var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "text_privacy", staticStyle: { "font-size": "16px" } },
      [
        _c("p", { staticStyle: { "text-align": "center" } }, [
          _c("strong", [
            _c("span", { staticStyle: { "font-size": "18pt" } }, [
              _vm._v("개인정보"),
            ]),
          ]),
        ]),
        _c("p", [_vm._v(" ")]),
        _c("p", [
          _c("strong", [_vm._v("제1조 수집하는 개인 정보 항목 및 수집방법")]),
        ]),
        _c("p", [
          _c("strong", [_vm._v("제2조 개인정보의 수집목적 및 이용목적")]),
        ]),
        _c("p", [_c("strong", [_vm._v("제3조 개인정보의 보유 및 이용 기간")])]),
        _c("p", [_c("strong", [_vm._v("제4조 개인정보의 파기 절차 및 방법")])]),
        _c("p", [_c("strong", [_vm._v("제5조 개인정보 제공 및 공유")])]),
        _c("p", [
          _c("strong", [
            _vm._v("제6조 이용자 및 법정대리인의 권리와 그 행사 방법"),
          ]),
        ]),
        _c("p", [
          _c("strong", [
            _vm._v(
              "제7조 개인정보 자동 수집 장치의 설치, 운영 및 그 거부에 관한 사항"
            ),
          ]),
        ]),
        _c("p", [
          _c("strong", [_vm._v("제8조 개인정보의 기술적/관리적 보호 대책")]),
        ]),
        _c("p", [_c("strong", [_vm._v("제9조 개인정보에 관한 민원 서비스")])]),
        _c("p", [_c("strong", [_vm._v("제10조 고지의 의무")])]),
        _c("p", [_vm._v(" ")]),
        _c("p", [_vm._v("<부칙>")]),
        _c("p", [
          _c("strong", [_vm._v("koda duck games")]),
          _vm._v(
            "(‘회사’라고 함)는 원활하고 편리한 서비스 제공을 위해 최선의 노력을 하고 있습니다. 또한 회사는 “정보통신망 이용촉진 및 정보보호 등에 관한 법률” (이하 ‘정보통신망법’) 및 관계 법령의 개인정보보호규정 등을 준수함으로써 회원의 개인정보 보호지침을 준수하고 있습니다."
          ),
        ]),
        _c("p", [
          _vm._v(
            "회사는 본 개인정보처리방침을 홈페이지 내 공개함으로써 회원이 언제나 용이하게 볼 수 있도록 하고 있습니다."
          ),
        ]),
        _c("p", [
          _vm._v(
            "회사의 본 개인정보처리방침은 정보의 법률 및 보호지침 변경이나 회사의 내부 방침 등으로 인하여 변경될 수 있으며, 변경되는 경우 회사는 변경 이유 및 내용에 대하여 즉시 홈페이지를 통해 공지합니다."
          ),
        ]),
        _c("p", [_vm._v("[ 용어의 정의 ]")]),
        _c("ul", [
          _c("li", [
            _vm._v(
              "“개인정보”라 함은 생존하는 개인에 관한 정보로서 당해 정보에 포함되어 있는 성명, 생년월일 등에 의하여 당해 개인을 식별할 수 있는 정보(당해 정보만으로는 특정 개인을 알아볼 수 없는 경우에도 다른 정보와 용이하게 결합하여 알아볼 수 있는 것을 포함)를 말합니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사는 회원의 개인정보를 수집하는 개인정보의 항목 및 수집 방법, 2. 개인정보의 수집 및 이용 목적에서 고지한 범위 내에서 이용하며, 동 범위를 초과하거나 변경하는 경우에는 사전에 이용자의 동의를 받습니다. 개인정보의 보유 및 이용 기간의 변경, 제3자 제공 및 처리 위탁 시 내용의 변경 또한 동일하며, 주요한 변경 내용에 대하여 이용자에게 모두 알리고 인터넷 사이트, 서면, 전화, 전자우편 등의 방법을 통하여 동의를 받습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회원의 가입 등의 절차에서 전자우편, 이동전화 등을 통해 영리 목적 광고의 수신과 관련하여 “동의한다”버튼을 클릭하면 영리 목적의 광고성 정보 수진에 동의한 것으로 확인합니다."
            ),
          ]),
        ]),
        _c("p", [_vm._v(" ")]),
        _c("p", [
          _c("strong", [_vm._v("제1조 수집하는 개인 정보 항목 및 수집방법")]),
        ]),
        _c("p", [
          _vm._v(
            "회사는 아래와 같은 항목 및 수집 방법을 통해 개인정보를 수집하고 있습니다."
          ),
        ]),
        _c("p", [
          _vm._v(
            "수집 항목 : ID 및 비밀번호, 비밀번호질문, 비밀번호답변, 성명, 생년월일, 주소, 전화번호, 휴대폰번호, SMS 수신여부, 이메일주소, 뉴스레터 수신여부, 아이핀번호, 개인식별번호, 성별, 닉네임, 접속 일시, 서비스 이용 기록, 법정대리인정보, 캐릭터명, PC IP, 회사는 회원가입 시 필수입력항목과 선택입력항목을 제시합니다. 회원 서비스 이용 신청자는 회사가 제공하는 회원제 서비스를 이용하기 위해서는 필수입력항목은 반드시 입력하여야 합니다. 단, 선택입력항목은 이를 입력하지 않더라도 회원제 서비스 이용에는 제한이 없습니다. 유료서비스를 이용하고자 하는 회원은 본인의 이용료 결제에 필요한 범위 내에서 은행계좌정보, 신용카드정보 등의 항목을 입력해야 하며 이는 이용표 결제를 위한 목적으로 사용됩니다. 수집 방법 : 홈페이지(회원가입), 서면 양식, 전화 회사는 입력하신 정보를 이용자들에게 사전에 밝힌 목적 이외에 다른 목적으로는 사용하지 않으며 외부로 유출하지 않습니다."
          ),
        ]),
        _c("p", [_vm._v(" ")]),
        _c("p", [
          _c("strong", [_vm._v("제2조 개인정보의 수집목적 및 이용목적")]),
        ]),
        _c("p", [
          _vm._v(
            "회사가 수집한 개인정보의 수집 및 이용 목적은 아래와 같습니다."
          ),
        ]),
        _c("p", [
          _vm._v(
            "서비스 제공에 관한 계약의 이행 및 서비스 제공에 따른 요금의 정산, 콘텐츠 제공 구매 및 요금 결제, 물품 배송 또는 청구서 등 발송, 금융 거래 본인 인증에 사용합니다. 회사는 이용자의 사전 동의 없이는 이용자의 개인정보를 함부로 공개하지 않으며, 수집된 정보는 아래와 같이 이용하고 있습니다. 회원의 관리 신용평가기관을 통한 실명 확인 및 본인 확인, 서비스 이용에 따른 본인 식별, 연령 제한 서비스의 제공, 만14세 미만 아동의 개인정보 수집 시 법정대리인 등의 동의 여부 확인, 미성년자의 법률 행위에 대한 법정대리인의 동의 또는 승인의 확인, 불만 처리 등 민원 처리, 고지사항의 전달 등 원활한 의사소통 경로의 확보, 비밀번호 분실 시 임시비밀번호의 발급 및 본인 확인, 분쟁 조정해결을 위한 기록보존, 불량회원의 부정이용방지와 비인가 사용방지, 중복가입의 확인에 사용합니다."
          ),
        ]),
        _c("p", [
          _vm._v(
            "신규 서비스 및 마케팅에의 활용 신규 서비스 및 이벤트 정보의 안내, 맞춤 서비스의 제공, 인구통계학적 특성에 따른 분석자료의 작성과 서비스의 제공 및 광고 게재에 사용합니다."
          ),
        ]),
        _c("p", [_vm._v(" ")]),
        _c("p", [_c("strong", [_vm._v("제3조 개인정보의 보유 및 이용 기간")])]),
        _c("p", [
          _vm._v(
            "회사는 원칙적으로 개인정보 수집 및 이용 목적이 달성된 후에는 해당 정보를 지체 없 이 파기 합니다."
          ),
        ]),
        _c("p", [
          _vm._v(
            "단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다."
          ),
        ]),
        _c("p", [
          _vm._v(
            "보존항목 : ID 및 비밀번호, 성명, 생년월일, 주소, 전화번호, 휴대폰번호, SMS 수신여부, 이메일주소,뉴스레터 수신여부, 접속 일시, 서비스 이용 기록, 캐릭터명, PC IP"
          ),
        ]),
        _c("ul", [
          _c("li", [
            _vm._v(
              "보존근거 : 회원 탈퇴 시 소비자의 불만 및 분쟁 해결 등을 위한 목적"
            ),
          ]),
          _c("li", [
            _vm._v(
              "보존기간 : 30일 상법, 전자상거래 등에서의 소비자 보호에 관한 법률 등 관계 법령의 규정에 의해 보존할 필요성이 있는 경우 회사는 관계법령에서 정한 일정한 기간 이상 회원의 개인 정보를 보관할 수 있습니다. 이 경우 회사는 보관하는 정보를 그 보관의 목적으로만 이용하며, 최소 보존 기간은 아래와 같습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "계약 또는 청약철회 등에 관한 기록 보존이유 : 전자상거래 등에서의 소비자보호에 관한 법률 보존기간 : 5년"
            ),
          ]),
          _c("li", [
            _vm._v(
              "대금결제 및 재화 등의 공급에 관한 기록 보존이유 : 전자상거래 등에서의 소비자보호에 관한 법률 보존기간 : 5년"
            ),
          ]),
          _c("li", [
            _vm._v(
              "소비자 불만 또는 분쟁처리에 관한 기록 보존이유 : 전자상거래 등에서의 소비자보호에 관한 법률 보존기간 : 3년"
            ),
          ]),
          _c("li", [
            _vm._v(
              "본인확인에 관한 기록 보존이유 : 정보통신망 이용촉진 및 정보보호 등에 관한 법률 보존기간 : 6개월"
            ),
          ]),
        ]),
        _c("p", [_vm._v(" ")]),
        _c("p", [_c("strong", [_vm._v("제4조 개인정보의 파기 절차 및 방법")])]),
        _c("p", [
          _vm._v(
            "회사는 원칙적으로 개인정보 수집 및 이용 목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 파기 절치 및 방법은 다음과 같습니다."
          ),
        ]),
        _c("ol", [
          _c("li", [
            _vm._v(
              "파기절차 회사는 회원이 일정 기간 동안 서비스를 이용하지 않거나 회원을 탈퇴한 경우 소비자의 불만 및 분쟁 해결 등을 위한 목적으로 90일간 개인정보를 보관 후, 재생이 불가능한 방법으로 파기합니다. 2)파기방법"
            ),
          ]),
        ]),
        _c("ul", [
          _c("li", [
            _vm._v(
              "전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다."
            ),
          ]),
        ]),
        _c("p", [_vm._v(" ")]),
        _c("p", [_c("strong", [_vm._v("제5조 개인정보 제공 및 공유")])]),
        _c("p", [
          _vm._v(
            "회사는 원칙적으로 이용자의 개인정보를 외부에 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다."
          ),
        ]),
        _c("p", [
          _vm._v(
            "이용자가 사전에 동의한 경우 서비스 제공에 따른 요금 정산을 위해 필요한 경우 전기통신기본법, 전기통신사업법 등 관계법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우 통계작성, 학술연구 또는 시장조사를 위하여 필요한 경우로서 특정 개인을 알아볼 수 없는 형태로 가공하여 제공하는 경우 회사는 회원에 대하여 보다 더 질 높은 서비스 제공 등을 위해 사전에 동의를 획득한 경우에 한하여 아래와 같이 회원의 개인정보를 제공하고 있습니다. 제공정보의 이용 목적 : 회원제 서비스 이용에 따른 본인 확인"
          ),
        ]),
        _c("ul", [
          _c("li", [_vm._v("제공대상 : 서울신용평가정보㈜")]),
          _c("li", [_vm._v("제공되는 정보 : 이름, 생년월일")]),
          _c("li", [
            _vm._v(
              "제공 정보의 보유 및 이용 기간 : 회원가입 시 실명 확인 및 본인 확인용으로 제공하는 것으로 별도 보유하지 않음 제공정보의 이용 목적 : 휴대폰결제와 관련된 분쟁의 해결을 대행"
            ),
          ]),
          _c("li", [_vm._v("제공 대상 : 휴대폰결제중재센터")]),
          _c("li", [_vm._v("제공되는 정보 : 이름, 생년월일, 휴대폰번호")]),
          _c("li", [
            _vm._v(
              "제공 정보의 보유 및 이용 기간 : 분쟁종료시 까지 제공정보의 이용 목적 : 유료서비스 이용에 따른 결제처리 및 요금정산"
            ),
          ]),
          _c("li", [_vm._v("제공 대상 : KG모빌리언스결제(대행업체 18000678)")]),
          _c("li", [
            _vm._v(
              "제공되는 정보 : 결제자 이름, 결제자 주민번호, 아이디, 아이피 정보"
            ),
          ]),
          _c("li", [
            _vm._v(
              "제공 정보의 보유 및 이용 기간 : 결제일 기준 5년 제공정보의 이용 목적 : 이벤트 및 마케팅"
            ),
          ]),
          _c("li", [
            _vm._v(
              "제공 대상 : 마케팅대행사(진행시 이벤트 및 마케팅 업체 공지)"
            ),
          ]),
          _c("li", [
            _vm._v(
              "제공하는 개인정보 항목: 아이디, 생년월일, 성명, 주소, 전화번호, 휴대폰번호, 아이피 정보"
            ),
          ]),
          _c("li", [_vm._v("제공 정보의 보유 및 이용 기간 : 회원탈퇴 시까지")]),
        ]),
        _c("p", [_vm._v(" ")]),
        _c("p", [
          _c("strong", [
            _vm._v("제6조 이용자 및 법정대리인의 권리와 그 행사 방법"),
          ]),
        ]),
        _c("p", [_vm._v("아동의 개인정보보호")]),
        _c("ul", [
          _c("li", [
            _vm._v(
              "회사는 만14세 미만 아동(이하 ‘아동’이라 합니다.)의 개인정보를 수집, 이용, 제공 등의 동의를 얻는 경우, 법정대리인의 동의를 받습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "만14세 미만 아동의 동의를 받기 위하여 회사는 법정대리인의 성명, 연락처 등 필요한 최소한의 정보를 요구할 수 있으며, 이와 같이 수집된 법정대리인의 개인정보는 해당 법정대리인의 동의 여부를 확인하는 목적 외의 용도로 이용되거나 제3자에게 제공하지 아니합니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "법정대리인의 동의서는 미성년자와 회사의 계약, 청약철회, 대금결제, 재화 공급 등이 발생할 시 소비자의 불만 및 분쟁 해결 등을 위한 용도로 이용됩니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "탈퇴한 아동의 법정대리인 동의서 또는 동의 철회, 유효기간이 만료된 법정대리인 동의서는 탈퇴 90일 이후에 재생이 불가능한 방법으로 파기됩니다. 다만, 상법, 전자상거래 등에서의 소비자 보호에 관한 법률 등 관계법령의 규정에 의해 보존할 필요성이 있는 경우 회사는 관계법령에서 정한 일정한 기간 동안 회원의 개인정보를 보관합니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "아동의 법정대리인은 당해 아동 개인정보의 열람, 정정 요구, 또는 개인정보의 수집 이용 또는 제공에 대한 동의의 철회를 요청할 수 있으며, 이러한 요청이 있을 경우 회사는 필요한 조치를 지체 없이 취하도록 합니다. 회원 자신의 개인정보 관리에 관한 사항"
            ),
          ]),
          _c("li", [
            _vm._v(
              "회원은 회사의 홈페이지 내 “회원정보변경>회원탈퇴”를 클릭하거나 개인정보관리책임자에게 서면, 전화, 전자우편 등을 통해 개인정보 수집에 대한 동의를 철회할 수 있으며, 그 경우 회사는 본인 여부를 확인한 후 법령에 다르게 규정하고 있는 경우를 제외하고는 당해 개인정보의 파기 등 조치를 취합니다. 단, 회원탈퇴로 인하여 개인정보가 파기가 되는 경우에는 해당 회원이 회사의 서비스를 이용하면서 생성, 축적한 관련 정보가 함께 파기될 수 있습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회원은 회사의 홈페이지 내 회원정보변경 페이지를 통하여 자신의 개인정보에 대한 열람 및 정정을 요구 할 수 있고 그 경우 회사는 필요한 조치를 취합니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사는 회원의 대리인이 방문하여 열람 또는 정정을 요구 하는 경우에는 회원의 진정한 대리인인지 여부를 확인하며 이 경우 회사는 대리 관계를 나타내는 증표를 제시하도록 요구할 수 있습니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "회사는 당해 개인정보의 전부 또는 일부에 대하여 열람 또는 회원의 개인정보 등에 대한 정정요구를 거절할 정당한 이유가 있는 경우에는 회원에게 이를 지체 없이 통지하고 그 이유를 설명합니다."
            ),
          ]),
          _c("li", [
            _vm._v(
              "성명, 생년월일, 이메일 주소 등 회원 가입 시 회원이 제공한 필수입력항목들의 변경은 회사가 제공하는 서비스에 오류 등을 발생시킬 수 있는 사항이기에, 회사는 원활하고 안정적인 서비스 제공을 위하여 회원의 필수입력항목 변경에 대해서는 해당 회원에게 별도로 절차를 요청할 수 있습니다."
            ),
          ]),
        ]),
        _c("p", [_vm._v(" ")]),
        _c("p", [
          _c("strong", [
            _vm._v(
              "제7조 개인정보 자동 수집 장치의 설치, 운영 및 그 거부에 관한 사항"
            ),
          ]),
        ]),
        _c("p", [
          _vm._v(
            "회사는 회원들에게 특화된 맞춤 서비스 등을 제공하기 위해서 회원의 정보를 수시로 저장하고 찾아내는 ‘쿠키(Cookie, 접속정보파일)’를 운용합니다."
          ),
        ]),
        _c("p", [
          _vm._v(
            "회사는 쿠키 운용과 관련하여 회원의 컴퓨터는 식별하지만 회원을 개인적으로 식별하지는 않습니다."
          ),
        ]),
        _c("p", [
          _vm._v(
            "-회원은 ‘쿠키’에 대한 선택권을 가지고 있습니다. 회원은 웹브라우저에서 [도구] > [인터넷옵션] > [보안] > [사용자정의수준]을 선택함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수 있습니다. 단, 모든 쿠키의 저장을 거부하는 경우, 쿠키를 통해 회사에서 제공하는 서비스를 이용할 수 없습니다."
          ),
        ]),
        _c("p", [_vm._v(" ")]),
        _c("p", [
          _c("strong", [_vm._v("제8조 개인정보의 기술적/관리적 보호 대책")]),
        ]),
        _c("p", [
          _vm._v(
            "회사는 회원의 개인정보를 처리함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안전성 확보를 위해 기술적 대책을 마련하고 있습니다. 회원 개인정보는 암호화되어 있어 본인만 알 수 있으며, 개인정보 확인 및 변경도 본인에 의해서만 가능합니다. 회사는 암호화 통신을 통하여 네트워크 상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다. 회사는 해킹이나 컴퓨터바이러스 등에 의해 회원의 개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다. 회사는 만약의 사태를 대비하여 개인정보를 주기적으로 백업하고 있으며, 백신프로그램을 이용하여 컴퓨터바이러스에 의한 피해를 방지하기 위한 조치를 취하고 있습니다. 회사는 시스템에 대한 접근통제, 권한관리, 취약점 점검 등의 조치를 통해 보안성이 강화될 수 있도록 지속적으로 노력하고 있습니다. 회사는 회원 개인정보에 대한 접근권한을 최소한의 인원으로 제한하고 있으며, 개인정보를 처리하는 직원을 대상으로 정기적인 교육을 실시하고 있습니다. 회사는 개인정보보호 업무를 전담하는 부서에서 개인정보처리방침 및 내부 규정 준수여부를 확인하여 문제가 발견될 경우, 즉시 바로 잡을 수 있도록 노력하고 있습니다. 회원 본인의 부주의나 인터넷상의 문제로 ID, 비밀번호, 생년월일 등의 개인정보가 유출되어 발생한 문제에 대해서는 회사가 일체 책임을 지지 않습니다."
          ),
        ]),
        _c("p", [_vm._v(" ")]),
        _c("p", [_c("strong", [_vm._v("제9조 개인정보에 관한 민원 서비스")])]),
        _c("p", [
          _vm._v(
            "회사는 고객의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 관련 부서 및 개인정보관리책임자를 지정하고 있습니다."
          ),
        ]),
        _c("p", [
          _vm._v(
            "귀하께서는 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보관리책임자 혹은 담당 부서로 신고하실 수 있습니다. 회사는 이용자들의 신고 사항에 대해 신속하게 충분한 답변을 드릴 것입니다."
          ),
        ]),
        _c("p", [
          _vm._v(
            "기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다."
          ),
        ]),
        _c("p", [_vm._v(" ")]),
        _c("p", [_c("strong", [_vm._v("제10페이스북 정보 수집 및 삭제")])]),
        _c("p", [
          _vm._v(
            "(1) 이용자가 Facebook 인증을 통해 애플리케이션에 로그인하는 경우, 당사는 주로 계정 생성 및 개인화된 서비스 제공을 목적으로 이용자의 이메일 주소와 개인정보를 수집합니다.\n\t\t(2) 이용자가 게임 애플리케이션을 삭제하거나 Facebook 설정 및 개인정보 보호에서 애플리케이션 승인을 제거하면 당사는 이용자의 모든 정보를 삭제합니다.\n\t\t(3) 이용자가 더 이상 페이스북 인증을 사용하여 로그인하지 않는 경우, 당사(nanservice01@gmail.com)로 연락하여 애플리케이션의 페이스북 인증 데이터 및 콘텐츠 정보를 삭제할 수 있으며, 삭제된 후에는 복구할 수 없습니다."
          ),
        ]),
        _c("p", [_vm._v(" ")]),
        _c("p", [_c("strong", [_vm._v("제11계정 삭제에 관한 주의사항")])]),
        _c("p", [
          _vm._v(
            '(1) 이용자가 본인의 의사에 따라 계정을 삭제하는 경우, 계정 삭제는 당사의 "계정 삭제 계약"에 동의하는 것으로 간주되며, 이용자는 당사와의 본 계약에 동의하고 계약의 모든 구속력 있는 조항을 자발적으로 수락하는 것으로 간주됩니다.'
          ),
        ]),
        _c("p", [
          _vm._v(
            "(2) 계정 삭제는 복구가 불가능한 작업으로, 계정을 삭제한 후에는 더 이상 해당 계정을 사용하여 당사의 모든 제품 및 서비스에 로그인할 수 없으며, 동일한 메일함을 선택하여 다시 등록하고 계정 관련 제품 및 서비스를 이용하더라도 계정을 통해 추가하거나 바인딩한 콘텐츠 및 정보를 검색할 수 없습니다.(3) 계정 삭제계정이 해지되면 계정 사용과 관련된 제품 및 서비스 상의 모든 콘텐츠, 정보, 데이터 및 기록은 삭제되거나 익명화됩니다(법률 및 규정에서 달리 규정하는 경우를 제외하고). 이로 인해 발생할 수 있는 모든 결과에 대한 책임은 회원님이 자발적으로 부담하셔야 합니다."
          ),
        ]),
        _c("p", [_vm._v(" ")]),
        _c("p", [_c("strong", [_vm._v("제12조 고지의 의무")])]),
        _c("p", [
          _vm._v(
            "본 개인정보처리방침은 법령 정책 또는 보안 기술의 변경에 따라 내용의 추가 삭제 및 수정이 있을 시에는 변경되는 개인정보처리방침을 시행하기 최소 7일 전에 홈페이지를 통해 변경 이유 및 내용 등을 공지하도록 하겠습니다."
          ),
        ]),
        _c("p", [_vm._v(" ")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }